var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplianceSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.496 6.10599L12.523 2.10599C12.3842 2.03616 12.2311 1.99962 12.0757 1.99927C11.9204 1.99892 11.7671 2.03478 11.628 2.10399L3.60101 6.10399C3.30401 6.25399 3.09901 6.54099 3.05701 6.87099C3.04401 6.96799 1.91201 16.612 11.598 21.879C11.7471 21.9597 11.9142 22.0013 12.0837 21.9997C12.2532 21.9981 12.4195 21.9535 12.567 21.87C21.874 16.611 21.081 7.29699 21.043 6.90299C21.0266 6.73473 20.9679 6.57338 20.8722 6.434C20.7765 6.29462 20.6471 6.18177 20.496 6.10599Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceSecurity);
export default __webpack_public_path__ + "static/media/ComplianceSecurity.904d2f25e0cb6aec362b7180bc75fb97.svg";
export { ForwardRef as ReactComponent };